/** Small stroke icons for the tabs and the theme menu. Inline so they take
 *  the text colour and need no font or network. */
const P = { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24', 'aria-hidden': true } as const

export const CompareIcon = () => (
  <svg {...P}><rect x="3" y="4" width="7" height="16" rx="1.5" /><rect x="14" y="4" width="7" height="16" rx="1.5" /><path d="M10 12h4" /></svg>
)
export const FitIcon = () => (
  <svg {...P}><rect x="6" y="6" width="12" height="12" rx="2" /><rect x="9.5" y="9.5" width="5" height="5" rx="1" /><path d="M9 2v4M15 2v4M9 18v4M15 18v4M2 9h4M2 15h4M18 9h4M18 15h4" /></svg>
)
export const CalculatorIcon = () => (
  <svg {...P}><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M8 7h8M8 12h2M12 12h2M16 12h0M8 16h2M12 16h2M16 16v0" /></svg>
)
export const SimulateIcon = () => (
  <svg {...P}><rect x="3" y="4" width="18" height="4" rx="1.5" /><rect x="3" y="10" width="18" height="4" rx="1.5" /><rect x="3" y="16" width="12" height="4" rx="1.5" /><path d="M18 18h3M19.5 16.5v3" /></svg>
)
export const OptimiseIcon = () => (
  <svg {...P}><path d="M4 19V5" /><path d="M4 19h16" /><path d="M8 15l4-5 3 3 5-7" /><path d="M17 6h3v3" /></svg>
)
export const TrendingIcon = () => (
  <svg {...P}><path d="M3 17l6-6 4 4 8-8" /><path d="M15 7h6v6" /></svg>
)
export const DataIcon = () => (
  <svg {...P}><ellipse cx="12" cy="6" rx="8" ry="3" /><path d="M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6" /><path d="M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" /></svg>
)
export const AskIcon = () => (
  <svg {...P}><path d="M4 5h16v10H9l-5 4z" /><path d="M9 9h6M9 12h3" /></svg>
)
export const AssessmentIcon = () => (
  <svg {...P}><path d="M9 4h6a1 1 0 0 1 1 1v1H8V5a1 1 0 0 1 1-1z" /><path d="M8 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" /><path d="M8.5 13.5l2.5 2.5 4.5-5" /></svg>
)
export const SunIcon = () => (
  <svg {...P}><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></svg>
)
export const MoonIcon = () => (
  <svg {...P}><path d="M21 13A8.5 8.5 0 0 1 11 3a7 7 0 1 0 10 10z" /></svg>
)
export const SystemIcon = () => (
  <svg {...P}><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M2 20h20M8 16v4M16 16v4" /></svg>
)
